import type { ICatalogo } from "../../../globales/interfaces";
import type { IContrato } from "../../../modelos/Contratos/entidades/IContrato";
import type { Table } from "@tanstack/react-table";

export interface ITablaContratosVistaProps {
    tabla: Table<IContrato>;
    consultarContratos: (page: number, size: number) => Promise<void>;
    maxHeight?: number;
     filtro: IContrato;
    // consultarContratos: () => void;
    manejarCambioFiltroContrato: (campo: keyof IContrato, valor: IContrato[keyof IContrato]) => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    indicePagina: number;
    TAMANIO_PAGINA: number;
}

export interface ITipoContrato {
    IdTipoContrato: number,
    TipoContrato: string;
}



export const estadoInicialContrato: IContrato = {
    Id: 0,
    ProyectoId: 0,
    Numero: '',
    FechaInicio: '',
    VigenciaMeses: 0,
    FechaFin: '',
    TipoContratoId: 0,
    ValorMensual: 0,
    CondicionesFacturacion: '',
    Activo: true,
    Eliminado: false,
    
    // NBS
    FechaInicioContractual: null,
    DiasInstalacionSegunContrato: null,
    FechaFinContractual: null,
    FechaTentativaEntregaCliente: null,
}

export interface IFiltroContratosVistaProps {
    filtro: IContrato;
    consultarContratos: () => void;
    manejarCambioFiltroContrato: (campo: keyof IContrato, valor: IContrato[keyof IContrato]) => void;
}


export interface IFormularioContratoVistaProps {
    contratoSeleccionado: IContrato;
    manejarCambioValorContrato: (campo: keyof IContrato, valor: any) => void;
    agregarError: (campo: keyof IContrato, mensaje: string) => void;
    errores: Partial<Record<keyof IContrato, string | null>>
    tiposContrato: ICatalogo[];
    guardarEditarContrato: () => void;
    cambiarContrato: (estado: boolean) => void;
    enCambioContrato: boolean;
    consultarContratoActivo: (contratoId: number) => Promise<void>
}